export enum AddOnProductType {
    ABC = 1,
    CarouselCollection,
}

export enum NotificationType {
    Collection = 1,
    Injection,
    Delivery,
    MissingBag = 7,
}

export enum NotificationStatus {
    Active = 1,
    ManuallyResolved,
    SystemResolved,
}
